import { render, staticRenderFns } from "./AS_ActsAndRules.vue?vue&type=template&id=42ee38d0&"
import script from "./AS_ActsAndRules.vue?vue&type=script&lang=js&"
export * from "./AS_ActsAndRules.vue?vue&type=script&lang=js&"
import style0 from "./AS_ActsAndRules.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports